import column from '../../abstract/column';
import vars from '../../abstract/vars';
import api from './api';

export default {
  actions: {},
  topRightActions: {},
  api,
  columns: {
    name: column({
      label: 'Nazwa',
      primary: true,
    }),
    state: column({
      label: 'Stan',
    }),
    consumers: column({
      label: 'Consumer',
    }),
    messages: column({
      label: 'Wiadomości',
    }),
    ingress_rate: column({
      label: 'Nowe',
      format: (item) => Number.parseFloat(item.ingress_rate).toFixed(2) + '/s',
    }),
    ack_rate: column({
      label: 'Ack rate',
      format: (item) => Number.parseFloat(item.ack_rate).toFixed(2) + '/s',
    }),
  },
  vars: vars({
    noItemsText: 'Brak kolejek',
    sidebarLabel: 'Podgląd kolejki',
  }),
};
